import request from '@/utils/request'

// 游戏接口：

// 新增游戏：post game/create，参数：
// title // 标题
// text // 备注
// order // 排序
//startTime // 每天开始时间，'HH:mm:ss'
// endTime // 每天结束时间，'HH:mm:ss'
export function create(data) {
    return request({
      url: '/game/create',
      method: 'post',
      data,
    })
  }
// 修改游戏：post game/update，参数：
// gameId // 游戏ID
// title // 标题
// text // 备注
// order // 排序
export function update(data) {
    return request({
      url: '/game/update',
      method: 'post',
      data,
    })
  }
// 删除游戏：post game/remove，参数：
// gameId // 游戏ID
export function remove(data) {
    return request({
      url: '/game/remove',
      method: 'post',
      data,
    })
  }
// 获取游戏列表：post game/findList，参数：
// keyword // 关键词，匹配标题
export function findList(params) {
    return request({
      url: '/game/findList',
      method: 'get',
      params,
    })
  }
// 新增战队：post game/createBattleTeam，参数：
// gameId // 游戏ID
// title // 标题
// avatar // 封面
// text // 备注
// order // 排序
export function createBattleTeam(data) {
    return request({
      url: '/game/createBattleTeam',
      method: 'post',
      data,
    })
  }
// 修改战队：post game/updateBattleTeam，参数：
// battleTeamId // 战队ID
// title // 标题
// avatar // 封面
// text // 备注
// order // 排序
export function updateBattleTeam(data) {
    return request({
      url: '/game/updateBattleTeam',
      method: 'post',
      data,
    })
  }
// 删除战队：post game/removeBattleTeam，参数：
// battleTeamId // 游戏ID
export function removeBattleTeam(data) {
    return request({
      url: '/game/removeBattleTeam',
      method: 'post',
      data,
    })
  }
// 获取战队列表：post game/findBattleTeamList，参数：
// keyword // 关键词，匹配标题
export function findBattleTeamList(params) {
    return request({
      url: '/game/findBattleTeamList',
      method: 'get',
      params,
    })
  }
// 获取所有战队：post game/findBattleTeamAll，参数：
// keyword // 关键词，匹配标题
export function findBattleTeamAll(params) {
    return request({
      url: '/game/findBattleTeamAll',
      method: 'get',
      params,
    })
  }

// 新增任务：post game/createBattleTask，参数：
// battleTeamId // 战队ID
// title // 标题
// typehood // 1:扫码，2：分享，3：注册会员
// score // 奖励积分
//codeList // 扫码列表，[{code//编码, score//积分, title//标题, text//备注}]
// maxCount // 最大可重复次数
// text // 备注
// order // 排序
export function createBattleTask(data) {
    return request({
      url: '/game/createBattleTask',
      method: 'post',
      data,
    })
  }
// 修改任务：post game/updateBattleTask，参数：
// battleTaskId // 任务ID
// title // 标题
// typehood // 1:扫码，2：分享，3：注册会员
// score // 奖励积分
// maxCount // 最大可重复次数
// text // 备注
// order // 排序
export function updateBattleTask(data) {
    return request({
      url: '/game/updateBattleTask',
      method: 'post',
      data,
    })
  }
// 删除任务：post game/removeBattleTask，参数：
// battleTaskId // 游戏ID
export function removeBattleTask(data) {
    return request({
      url: '/game/removeBattleTask',
      method: 'post',
      data,
    })
  }
// 获取任务列表：post game/findBattleTaskList，参数：
// keyword // 关键词，匹配标题
export function findBattleTaskList(params) {
    return request({
      url: '/game/findBattleTaskList',
      method: 'get',
      params,
    })
  }
// 获取所有任务：post game/findBattleTaskAll，参数：
// keyword // 关键词，匹配标题
export function findBattleTaskAll(params) {
    return request({
      url: '/game/findBattleTaskAll',
      method: 'get',
      params,
    })
  }
// 新增礼品：post game/createBattleGift，参数：
// gameId // 游戏ID
// title // 标题
// avatar // 封面
// text // 备注
// order // 排序
export function createBattleGift(data) {
    return request({
      url: '/game/createBattleGift',
      method: 'post',
      data,
    })
  }
// 修改礼品：post game/updateBattleGift，参数：
// battleGiftId // 礼品ID
// title // 标题
// avatar // 封面
// text // 备注
// order // 排序
export function updateBattleGift(data) {
    return request({
      url: '/game/updateBattleGift',
      method: 'post',
      data,
    })
  }
// 删除礼品：post game/removeBattleGift，参数：
// battleGiftId // 礼品ID
export function removeBattleGift(data) {
    return request({
      url: '/game/removeBattleGift',
      method: 'post',
      data,
    })
  }
// 获取礼品列表：post game/findBattleGiftList，参数：
// keyword // 关键词，匹配标题
export function findBattleGiftList(params) {
    return request({
      url: '/game/findBattleGiftList',
      method: 'get',
      params,
    })
  }
// 获取所有礼品：post game/findBattleGiftAll，参数：
// keyword // 关键词，匹配标题
export function findBattleGiftAll(params) {
    return request({
      url: '/game/findBattleGiftAll',
      method: 'get',
      params,
    })
  }
  // 完成战队任务
//   完成战队任务接口：post game/finishBattleTaskRecord，参数：
// gameId // 游戏ID
// battleTaskId // 任务ID
// code // 编码
export function finishBattleTaskRecord(data) {
  return request({
    url: '/game/finishBattleTaskRecord',
    method: 'post',
    data,
  })
}
// 中奖记录和核销
// 获取游戏发奖记录：get game/findBattleGiftRecordList, 参数：
// gameId // 游戏ID
// date // 当天日期，YYYY-MM-DD
// page // 1
// size // 1
export function findBattleGiftRecordList(params) {
  return request({
    url: '/game/findBattleGiftRecordList',
    method: 'get',
    params,
  })
}

// 新增核销礼品记录接口：post game/finishBattleGiftRecord，参数：
// gameId // 游戏ID
// battleGiftRecordId // 记录ID
export function finishBattleGiftRecord(data) {
  return request({
    url: '/game/finishBattleGiftRecord',
    method: 'post',
    data,
  })
}
// 
// 后台获取玩家积分排行版：get game/findPeopleScoreRank，参数：
// gameId // 游戏ID
export function findPeopleScoreRank(params) {
  return request({
    url: '/game/findPeopleScoreRank',
    method: 'get',
    params,
  })
}
// 后台获取战队积分排行榜，get game/findBattleTeamScoreRank，参数：
// gameId // 游戏ID
export function findBattleTeamScoreRank(params) {
  return request({
    url: '/game/findBattleTeamScoreRank',
    method: 'get',
    params,
  })
}
// 后台获取玩家获取积分明细列表，get game/findScoreRecordList ,参数：
// gameId
// page
// size
export function findScoreRecordList(params) {
  return request({
    url: '/game/findScoreRecordList',
    method: 'get',
    params,
  })
}